<template>
	<div>
		<el-time-picker v-if="this.type == 'time'" ref="timePickerRef" format="HH:mm" value-format="HH:mm" v-model="inputValue" @change="handleInputConfirm" :placeholder="`${$t('Actions.Add')}`" />

		<cbs-date-picker
			v-if="this.type != 'time'"
			class="input-new-tag"
			v-validate="'required'"
			:type="this.type"
			prefix-icon="''"
			ref="dtimePickerRef"
			:format="format(userDateFormat, userTimeFormat, userDateTimeFormat)"
			value-format="yyyy-MM-dd HH:mm"
			v-model="inputValue"
			@change="handleInputConfirm"
			:placeholder="`${$t('Actions.Add')}`"
		/>
		<div class="mt-3">
			<el-tag :key="tag" v-for="tag in localValue" closable :disable-transitions="false" @close="handleClose(tag)">
				{{ tag }}
			</el-tag>
		</div>
	</div>
</template>

<script>
import CbsDatePicker from "@/components/cbs-date-picker/CbsDatePicker";

export default {
	name: "CbsMultiDate",
	inject: ["parentValidator"],

	props: {
		value: {
			type: Array,
			required: true
		},
		type: {
			type: String,
			default: "date" // year/month/date/dates/datetime/ week/datetimerange/daterange/ monthrange time
		}
	},
	components: {
		CbsDatePicker
	},
	computed: {
		localValue: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		}
	},
	data() {
		return {
			inputValue: ""
		};
	},
	methods: {
		format(date, time, datetime) {
			switch (this.type) {
				case "time":
					return time;
				case "datetime":
					return datetime;
			}
			return date;
		},
		handleClose(tag) {
			this.localValue.splice(this.localValue.indexOf(tag), 1);
		},

		showInput() {
			/* eslint-disable */
			this.$nextTick(_ => {
				this.$refs.saveTagInput.$refs.input.focus();
			});
			/* eslint-enable */
		},

		addValue(val) {
			if (this.localValue && !this.localValue.includes(val)) {
				this.localValue.push(val);
			}
		},
		handleInputConfirm() {
			let inputValue = this.inputValue;
			if (inputValue) {
				this.addValue(this.inputValue);
			}
			this.inputValue = "";
		}
	},
	created() {
		if (this.parentValidator) {
			this.$validator = this.parentValidator;
		}
	}
};
</script>

<style>
.el-tag + .el-tag {
	margin-left: 10px;
}

.input-new-tag {
	width: 110px !important;
	margin-left: 10px;
	vertical-align: bottom;
}
</style>
